'use client';

import { c as _c } from "react/compiler-runtime";
import { NexperienceAvailableAndAlternativeDatesDocument } from '@data-access/lib/gql/experience/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { keepPreviousData } from '@tanstack/react-query';
import { endOfDayInDefaultTimeZone, startOfDayInDefaultTimeZone } from '@utils/helpers';
import { useExperienceFilterContext } from '../_components/app-experience-filter-provider';
import { EXPERIENCE_AVAILABILITY_STALE_TIME, getExperienceTimeslotsPreviewVariables } from '../_lib/experience-availability-query';
import { useExperiencePreviewToken } from './use-experience-preview-token';
export function useEdpTimeslotsForDate(selectedDate) {
  const $ = _c(15);
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const previewToken = useExperiencePreviewToken();
  let t0;
  if ($[0] !== filter || $[1] !== selectedDate) {
    t0 = selectedDate ? {
      ...filter,
      from: startOfDayInDefaultTimeZone(selectedDate),
      to: endOfDayInDefaultTimeZone(selectedDate)
    } : filter;
    $[0] = filter;
    $[1] = selectedDate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const dateFilter = t0;
  let t1;
  if ($[3] !== dateFilter || $[4] !== experience.publicId || $[5] !== previewToken) {
    t1 = getExperienceTimeslotsPreviewVariables({
      publicId: experience.publicId,
      previewToken,
      filter: dateFilter
    });
    $[3] = dateFilter;
    $[4] = experience.publicId;
    $[5] = previewToken;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const variables = t1;
  const t2 = !!selectedDate && !!filter.selectedVariant;
  let t3;
  if ($[7] !== t2) {
    t3 = {
      enabled: t2,
      select: _temp,
      staleTime: EXPERIENCE_AVAILABILITY_STALE_TIME,
      placeholderData: keepPreviousData
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data,
    isLoading,
    isPlaceholderData
  } = useGraphQL(NexperienceAvailableAndAlternativeDatesDocument, variables, t3);
  let t4;
  if ($[9] !== data) {
    t4 = data ?? [];
    $[9] = data;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isLoading || $[12] !== isPlaceholderData || $[13] !== t4) {
    t5 = {
      dates: t4,
      isLoading,
      isPreliminary: isPlaceholderData
    };
    $[11] = isLoading;
    $[12] = isPlaceholderData;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(response) {
  return response.nexperienceAvailableDates.dates;
}